import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { Injectable } from "@angular/core";
import { GameToLoad } from "../state/game/game.state";
import { GameService } from "../firebase/game.service";
import { TournamentService } from "../firebase/tournament.service";
import { ProfileService } from "../firebase/profile.service";
import { TableType } from "@soposopo/sopo-models";


@Injectable({
    providedIn: 'root'
})
export class GamePageGuard  { 

    constructor(
        private router: Router,
        public route: ActivatedRoute,
        private gameService: GameService,
        private tournamentService: TournamentService,
        private profileService: ProfileService,
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise < boolean | UrlTree > {
        return new Promise(async (resolve, reject) => {
                const game = await this.getGamesArray();

                if (game == null) {
                    const url: UrlTree = this.router.parseUrl('/lobby');
                    resolve(url);
                } else {
                    resolve(true);
                }
            });
    }

    async getGamesArray() : Promise<GameToLoad> {
        let gameStateId : string;
        let tournamentId : string | undefined;

        // In Electron, window.name is not set automatically (unlike browser's window.open).
        // The preload script exposes __gameTabName (passed via additionalArguments from TabManager).
        if (!window.name || !window.name.startsWith('gameTab-')) {
            const gameTabName = window.__gameTabName;
            if (gameTabName) {
                window.name = gameTabName;
            }
        }

        const channel = new BroadcastChannel('gameTab-manager');
        channel.postMessage({ type: 'TAB_OPENED', gameTabName: window.name });
        channel.close();

        const tabName = window.name.split("-");
        
        if(tabName.length === 3) { //its a tournament tab (gameTab-tournamentId-gameStateId)
            tournamentId = tabName[1];
            gameStateId = tabName[2];
        }
        else { //its not a tournament tab (gameTab-gameStateId)
            gameStateId = tabName[1];
        }

        const queryString = localStorage.getItem('gameInfo-' + gameStateId);
        if (queryString === null || queryString === '[]') {
            if (gameStateId) {
                if (tournamentId) {
                    const tournamentGame = await firstValueFrom(this.tournamentService.getTournamentObservable(tournamentId));
                    const playerId = await firstValueFrom(this.profileService.getMyUserId());
                    const tableResult = await this.tournamentService.getPlayersTable(tournamentId, playerId);
                    const tableId = tableResult.id;
                    return {
                        componentType: "game",
                        gameStateId: gameStateId,
                        tableId: tableId,
                        tournamentId: tournamentId,
                        type: tournamentGame.tournamentType as TableType,
                        clubId: tournamentGame.clubID,
                    };
                } else {
                    const game = await firstValueFrom(this.gameService.getTableObservable(gameStateId));
                    return {
                        componentType: 'game',
                        gameStateId: gameStateId,
                        tableId: gameStateId,
                        tournamentId: undefined,
                        type: TableType.RING,
                        clubId: game.clubId,
                    };
                }
            }
            return null;
        } else {
            return JSON.parse(queryString);
        }
    }

}
